"use client";

import React from "react";
import styled from "styled-components";
const InnerStyled = styled.div.withConfig({
  displayName: "ClickOutside__InnerStyled",
  componentId: "sc-4ccc69-0"
})(["width:100%;"]);

/**
 * @deprecated use useClickOutside hook instead
 */

export default function ClickOutside({
  children,
  onClickOutside
}) {
  const ref = React.useRef(null);
  React.useEffect(() => {
    const handleClickOutside = ev => {
      if (onClickOutside && ref.current && !ref.current.contains(ev.currentTarget)) {
        onClickOutside(ev);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClickOutside]);
  return /*#__PURE__*/React.createElement(InnerStyled, {
    ref: ref
  }, children);
}